import _ from 'lodash';

export default {
  notices: (state, getters, rootState, rootGetters) => {
    // return _.sortBy(state.notices, ['fixed', 'regDate']).reverse();
    return _.sortBy(state.notices, ['regDate']).reverse();
  },
  topNotice: (state, getters, rootState, rootGetters) => {
    let firstNotice = getters.notices[0];
    if(firstNotice?.fixed) 
      return firstNotice;
  },
  fixedNotice: (state, getters, rootState, rootGetters) => {
    return state.notices.find(el => el.fixed == true);
  },
  findByShareFileId:(state, getters) => ({shareFileId}) => {
    return state.notices.find(el => el.roomFileId == shareFileId);
  },
}
